import './Popup.scss';
import template from './Popup.vhtml';

export default {
	name: 'Popup',
	template: template,
	props: {},
	data: () => ({}),
	computed: {},
	methods: {},
};
